import { makeStyles, alpha } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  header: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    ...condensedStyles(theme, { gap: theme.spacing(3), marginBottom: theme.spacing(5) })
  },
  // Condensed layout only: the customer workspace's breadcrumb.
  breadcrumb: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginBottom: 0,
    fontSize: 13,
    color: theme.colorPalette.beige_90,
    '& a': {
      color: 'inherit',
      textDecoration: 'underline',
      textUnderlineOffset: '3px'
    }
  },
  subtitle: {
    margin: 0,
    color: theme.colors.text_secondary
  },
  rowTop: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
    ...condensedStyles(theme, { flexWrap: 'wrap' })
  },
  backButton: {
    position: 'absolute',
    top: theme.spacing(2),
    left: -theme.spacing(14),
    width: 40,
    height: 40,
    padding: 0
  },
  backIcon: {
    width: 40,
    height: 40
  },
  colLeft: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    margin: 0,
    lineHeight: '56px',
    color: theme.colorPalette.green_90,
    overflowWrap: 'anywhere',
    ...condensedStyles(theme, { '&&': { fontSize: 26, lineHeight: '32px', fontWeight: 600 } })
  },
  titleLink: {
    font: 'inherit',
    color: 'inherit',
    textDecoration: 'underline',
    textUnderlineOffset: 4
  },
  coApplicant: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2)
  },
  coApplicantLabel: {
    lineHeight: '12px',
    paddingBottom: 3
  },
  coApplicantName: {
    lineHeight: '24px'
  },
  simulatedSourceBadge: {
    '&&': {
      maxWidth: 'none',
      width: 'fit-content',
      marginTop: theme.spacing(2),
      backgroundColor: theme.colorPalette.beige_25,
      color: theme.colorPalette.beige_90,
      ...reskinStyles(theme, theme.labelStyles.outlined)
    }
  },
  colRight: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  rowBottom: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.spacing(4),
    borderTop: `1px solid ${alpha(theme.colorPalette.beige_75, 0.5)}`
  },
  column: {
    paddingTop: theme.spacing(4),
    '& + &': {
      paddingLeft: theme.spacing(4),
      borderLeft: `1px solid ${alpha(theme.colorPalette.beige_75, 0.5)}`
    }
  },
  preBindIdColumn: {
    flex: '0 0 184px'
  },
  repColumn: {
    flex: '0 0 192px'
  },
  quoteSourceColumn: {
    flex: '1 1 0',
    minWidth: 0
  },
  referredByColumn: {
    flex: '0 0 192px'
  },
  // Condensed layout: QuoteFacts as a stacked list inside a side-column card.
  factsCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '& > $column': {
      flex: 'none',
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.2fr)',
      gap: theme.spacing(2),
      alignItems: 'baseline',
      '& > *': { fontSize: 14, lineHeight: '20px', overflowWrap: 'anywhere' },
      paddingTop: 0
    },
    '& > $column + $column': {
      paddingLeft: 0,
      borderLeft: 0
    }
  },
  copyButton: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 2,
    maxWidth: '100%',
    padding: 0,
    border: 0,
    background: 'none',
    font: 'inherit',
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.orange_50,
    ...reskinStyles(theme, { color: theme.colors.action_text }),
    cursor: 'pointer'
  },
  copyIcon: {
    flexShrink: 0,
    width: 24,
    height: 24
  }
}));

export default useStyles;
